import moment from "moment";
import { FirestoreService } from "../../../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../../../api/firebase/references";
import { getOrgIdForFetchExternalWorklist } from "../../../../utils/organizationHelper";

export interface ProcessedOrdersData {
  completion_percentage: number;
  orders_processed: number;
  orders_remaining: number;
  time_taken: string;
  loading: boolean;
}

export const fetchProcessedOrdersData =
  async (): Promise<ProcessedOrdersData> => {
    try {
      const orgId = getOrgIdForFetchExternalWorklist();

      if (orgId === "") {
        return {
          completion_percentage: 0,
          orders_processed: 0,
          orders_remaining: 0,
          time_taken: "",
          loading: false,
        };
      }

      const currentDateInDashedFormat = moment().format("YYYY-MM-DD");
      const data = await FirestoreService.getDocument(
        FirestoreDocumentReference.processedOrdersToday(
          orgId,
          currentDateInDashedFormat,
        ),
      );

      const completion_percentage =
        data?.["processing_progress"]?.["completion_percentage"] || 0;
      const orders_processed =
        data?.["processing_progress"]?.["orders_processed"] || 0;
      const orders_remaining =
        data?.["processing_progress"]?.["orders_remaining"] || 0;
      const created_at = data?.["created_at"] || "";
      const updated_at = data?.["updated_at"] || "";

      return {
        completion_percentage,
        orders_processed,
        orders_remaining,
        time_taken:
          moment(updated_at).diff(moment(created_at), "minutes") + " mins",
        loading: false,
      };
    } catch (error) {
      console.error("Error fetching processed orders data:", error);
      return {
        completion_percentage: 0,
        orders_processed: 0,
        orders_remaining: 0,
        time_taken: "",
        loading: false,
      };
    }
  };
